import React from 'react';
import PropTypes from 'prop-types';
import Carousel from './Carousel.js';
/* eslint-disable max-len */
import HomePageHero from './HomePageHero.js';
import breakpoints from './breakpoints';
/* eslint-enable max-len */
const ORGANISM_NAME = 'hero-carousel';

export default class HeroCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDesktop: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleNavigationClick = this.handleNavigationClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('click', this.handleNavigationClick);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('click', this.handleNavigationClick);
  }

  // /* Work around for checking if navigation is open/close */
  handleNavigationClick(e) {
    const el = e.target;
    const carousel = this.refs.carousel;

    if (el.rel === 'menuitem') {
      carousel.pause();
    } else {
      if (el.getAttribute('role') === 'button' && el.title === 'Close') {
        carousel.resume();
      }
    }
  }

  handleResize() {
    const newWindowWidth = this.organismRef.ownerDocument.defaultView.innerWidth ||
      this.organismRef.ownerDocument.documentElement.clientWidth ||
      this.organismRef.ownerDocument.body.clientWidth;

    if (newWindowWidth > breakpoints.large) {
      if (!this.state.isDesktop) {
        this.setState({
          isDesktop: true,
        });
      }
    } else {
      if (this.state.isDesktop) {
        this.setState({
          isDesktop: false,
        });
      }
    }
  }

  renderHero(slides) {
    const { timezone, language } = this.props;

    if (slides) {
      return slides.map((props, idx) => (
        <HomePageHero
          {...props}
          index={idx}
          country={this.props.country}
          locale={this.props.locale}
          className={`${ORGANISM_NAME}__carousel__hero`}
          key={`${ORGANISM_NAME}-${idx}`}
          height={this.props.carouselInfo.config.height}
          timezone={timezone}
          language={language}
        />
      ));
    }
    return null;
  }

  renderCarousel(slides) {
    const { autoplayInterval, wrapAround } = this.props.carouselInfo.config;
    let options = {
      startSlide: 0,
      speed: 400,
      className: ORGANISM_NAME,
      continuous: false,
    };

    /** desktop only defaults **/
    if (this.state.isDesktop) {
      options = Object.assign({}, options, {
        auto: autoplayInterval || 0,
        continuous: (wrapAround !== undefined) ? wrapAround : true,
      });
    }

    const newKey = `${this.state.isDesktop.toString() +
      slides.length +
      (this.props.carouselInfo.config.height || 'tall')}`;

    return (
      <div
        key={newKey}
        className={`${ORGANISM_NAME}__wrapper`}
      >
        <Carousel
          ref="carousel"
          className={`${ORGANISM_NAME}__carousel`}
          trackId={this.props.carouselInfo.config.trackId}
          styles={this.props.carouselInfo.styles}
          options={options}
          content={this.props.carouselInfo.content.carousel}
          numberCounterThreshold={this.props.carouselInfo.config.numberCounterThreshold}
          renderNumberCounter={this.props.carouselInfo.config.renderNumberCounter}
        >
          {this.renderHero(slides)}
        </Carousel>
      </div>
    );
  }

  render() {
    const slides = this.props.carouselInfo.slides;
    const heroCarouselClasses = ORGANISM_NAME;
    const palBlue = 'circle at 0 0, #0070ba, #1546a0';
    if (slides.length > 0) {
      return (
        <section
          ref={(c) => {
            this.organismRef = c;
          }}
          className={heroCarouselClasses}
          data-building-block="organism"
        >
          {this.renderCarousel(slides)}
        </section>
      );
    } else {
      return (
        <section ref={(c) => {
          this.organismRef = c; 
        }} className="home-carousel-hero" style={{ backgroundImage: `radial-gradient(${palBlue})` }}>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-lg-9 center-block text-xs-center" >
                <h1 className="home-carousel-hero__headline">{'Welcome to Business Resource Center'}</h1>
              </div>
            </div>
          </div>
        </section>
      );
    }
  }
}

HeroCarousel.propTypes = {
  carouselInfo: PropTypes.shape({
    config: PropTypes.shape({
      id: PropTypes.string,
      autoplayInterval: PropTypes.number,
      trackId: PropTypes.string,
      wrapAround: PropTypes.bool,
      height: PropTypes.string,
      theme: PropTypes.string,
      numberCounterThreshold: PropTypes.number,
      renderNumberCounter: PropTypes.bool,
    }),
    styles: PropTypes.shape({
      container: PropTypes.object,
      wrapper: PropTypes.object,
      child: PropTypes.object,
    }),
    content: PropTypes.shape({
      carousel: PropTypes.shape({
        goToSlide: PropTypes.shape({
          text: PropTypes.string.isRequired,
        }),
        goToNextSlide: PropTypes.shape({
          text: PropTypes.string.isRequired,
        }),
        goToPreviousSlide: PropTypes.shape({
          text: PropTypes.string.isRequired,
        }),
      })
    }),
    slides: PropTypes.array
  })
};
